import React, { useState } from 'react'
import logo from '../assets/GiftBoxLogo_white.svg'

import credit_1 from '../assets/Group 21969.png'
import credit_2 from '../assets/Mask Group 61.png'
import credit_3 from '../assets/Mask Group 62.png'
import credit_4 from '../assets/Group 63.png'

import { lambda } from '../Functions'

export default function Footer() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const subscribe = async () => {
        setLoading(true);      // Start loading
        setMessage('');        // Clear any old message

        try {
            const response = await fetch(`${lambda}?action=Subscribe`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            if (response.ok) {
                setMessage('Subscribed successfully! 🎉');
                setEmail(''); // Clear email input after success
            } else {
                const errorData = await response.json();
                console.error(errorData);
                setMessage('There was an error. Please try again.');
            }
        } catch (error) {
            console.error(error);
            setMessage('There was an error. Please try again.');
        } finally {
            setLoading(false);  // Stop loading
        }
    };

    return (
        <section className='mt-12' style={{ background: '#000000' }}>
            <div className='container py-4'>
                <div className='row'>
                    <div className='col-md-4 d-flex flex-column align-items-start mt-3'>
                        <img src={logo} style={{ height: '4rem' }} alt="GiftBox Logo" />
                        <p className='pt-2' style={{ color: 'white' }}>
                            Giftbox makes gifting easy <br />
                            and seamless. Shop, send, <br />
                            or redeem vouchers from top <br />
                            global brands in 190+ countries.
                        </p>
                    </div>

                    <div className='col-md-4 d-flex flex-column justify-content-between mt-3'>
                        <a href='/' className='light'>Home</a>
                        <a href='/products' className='light'>Products</a>
                        <a href='/contact' className='light'>Contact Us</a>
                    </div>

                    <div className='col-md-4 mt-3'>
                        <p style={{ color: 'white' }}>Subscribe to our emails</p>

                        <div className='d-flex flex-column gap-2 flex-wrap'>
                            <div className='d-flex flex-row gap-2'>
                                <input 
                                    placeholder='Enter your email' 
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />

                                <button 
                                    className='bg_purple br_10' 
                                    onClick={subscribe}
                                    style={{ 
                                        fontSize: '1.6rem', 
                                        color: 'white', 
                                        border: '1px solid rgba(63, 44, 139, 0.03)', 
                                        padding: '1rem 2rem' 
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Subscribe'}
                                </button>
                            </div>

                            {/* Show the message here */}
                            {message && (
                                <p style={{ color: message.includes('success') ? 'green' : 'red' , fontWeight:700 }}>
                                    {message}
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                <div className='mt-5' style={{ width: '100%', border: '0.1px solid #ffffff4d' }}></div>

                <div className='d-flex justify-content-between pt-5 flex-wrap'>
                    <div className='d-flex gap-5 mt-4'>
                        <a href='#' className='light'>Privacy Policy</a>
                        <a href='#' className='light'>Refund Policy</a>
                        <a href='#' className='light'>Terms & Condition</a>
                    </div>

                    <div className='d-flex gap-3 align-items-center justify-content-center flex-wrap mt-4'>
                        <p className='m-0'>© 2025, Giftbox</p>
                        <div className='d-flex gap-1' style={{ height: '25px' }}>
                            <img src={credit_1} alt="credit card 1" />
                            <img src={credit_2} alt="credit card 2" />
                            <img src={credit_3} alt="credit card 3" />
                            <img src={credit_4} alt="credit card 4" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
